import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Header from "../../CustomComponents/Header/Header";
import Footer from "../../CustomComponents/Footer/Footer";
import CustomListingCard from "../../CustomComponents/CustomListingCard/CustomListingCard";
import FilterHoliday from "../../CustomComponents/FilterSection/FilterHoliday";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound";
import SendEnquiryPopup from "../../CustomComponents/SendEnquiryPopup/SendEnquiryPopup";
import Slider from "react-slick";
import imgNotFound from "../../assets/images/single-image.png";
import NewSendEnquiryPopup from "../../CustomComponents/NewSendEnquiryPopup/NewSendEnquiryPopup";
import NewUIPackageCard from "../../CustomComponents/NewComponents/NewUIPackages/NewUIPackageCard";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI";
import { Fancybox } from "@fancyapps/ui";
import styles from "./AllThemesPackages.module.scss";
import Loader from "../../CustomComponents/Loader/Loader";
import Skeleton from "react-loading-skeleton";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData";


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} arrowRight slideArrows`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} arrowLeft slideArrows`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function AllThemesPackages() {
  const [singleTheme, setSingleTheme] = useState([]);
  const [themeName, setThemeName] = useState("");
  const location = useLocation();
  const { id, handle } = useParams();
  const [showSendEnquiryPopup, setShowSendEnquiryPopup] = useState(false);

  // useEffect(() => {
  //   const query = new URLSearchParams(location.search);
  //   setThemeName(query.get("themename"));
  //   if (id) {
  //     fetchThemesPkg(id);
  //   }
  // }, [id, location.search]);

  const fetchThemesPkg = (id) => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/themes/single/${handle}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setSingleTheme(data?.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching  details:", error);
      });
  };

  useEffect(() => {
    fetchThemesPkg();
  }, []);

  const settings = {
    dots: false,
    infinite: singleTheme?.themeImages > 1,
    speed: 500,
    slidesToShow: Math.min(singleTheme?.themeImages, 3),
    slidesToScroll: 1,
    nextArrow: false,
    prevArrow: false,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const slider = React.useRef(null);

  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  return (
    <>
      <PageMetaData
            title={`${
              singleTheme?.metaData?.metaTitle
                ? singleTheme.metaData.metaTitle
                : singleTheme?.title || ""
            } `}
            description={
              singleTheme?.metaData?.metaDescription
                ? singleTheme.metaData.metaDescription
                : ""
            }
            keywords={
              singleTheme?.metaData?.metaKeywords
                ? singleTheme.metaData.metaKeywords
                : ""
            }
          />
      <NewUiHeader />
      {loader ? (
        <div className="container">
          <div className={styles?.single_destination_overview_content}>
            {Array.from({ length: 1 }).map((_, index) => (
              <div className="gallery" key={index}>
                <div>
                  <Skeleton height={350} />
                </div>
                <div className="gallery2">
                  <div>
                    <Skeleton height={170} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={170} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={170} />
                  </div>
                  <div className="SingleHotel-gallary-sm">
                    <Skeleton height={170} />
                  </div>
                </div>
              </div>
            ))}
            <div>
              <h3 style={{ textAlign: "left" }}>
                <Skeleton width={600} />
              </h3>

              <div className="destinationsCard mt-10">
                {Array.from({ length: 8 }).map((_, index) => (
                  <div className="card" key={index} style={{width:"333px"}}>
                    <div className="hotelCardImg">
                      <Skeleton height={170} />
                    </div>
                    <div className="hotel-content-flex hotel-main-card">
                      <div className="" style={{ background: "#fff" }}>
                        <Skeleton height={193} />
                      </div>

                      <div className="hotel-content" style={{ width: "100%" }}>
                        <div className="hotel_main border_0">
                          <h4>
                            <b>
                              <Skeleton width={100} />
                            </b>
                          </h4>
                          <div>
                            <Skeleton width={70} />
                          </div>
                          <small>
                            <Skeleton width={200} />
                          </small>
                          <div className=" flex justify_content_between w-full align_items_end">
                            <div>
                              <p>
                                <Skeleton width={100} />
                              </p>
                              <h5>
                                <Skeleton width={50} />
                              </h5>
                            </div>
                            <div className="view_room_btn">
                              <Skeleton />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <section className="new_ui_bg">
          <section style={{ padding: "20px 0" }}>
            <div className="container">
              <div className={styles?.single_destination_overview_content}>
                <div
                  style={{
                    fontWeight: "400",
                    fontSize: "30px",
                    lineHeight: "100%",
                  }}
                  className={styles?.font_playfair}
                >
                  {singleTheme?.title}
                </div>
                {singleTheme && singleTheme?.themeImages && (
                  <div className="gallery" style={{ marginBottom: "0" }}>
                    <div>
                      <img
                        src={
                          singleTheme?.themeImages[0]
                            ? singleTheme?.themeImages[0]
                            : imgNotFound
                        }
                        alt="hotel-image"
                      />
                      {singleTheme?.themeImages?.length > 1 && (
                        <div>
                          <button
                            className="images_btn"
                            onClick={() => {
                              Fancybox.show(
                                singleTheme?.themeImages?.map((src) => ({
                                  src,
                                  type: "image",
                                }))
                              );
                            }}
                          >
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 16 15"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
                            </svg>
                            See all images
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="gallery2">
                      <div>
                        <img
                          src={
                            singleTheme?.themeImages[1]
                              ? singleTheme?.themeImages[1]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <img
                          src={
                            singleTheme?.themeImages[2]
                              ? singleTheme?.themeImages[2]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <img
                          src={
                            singleTheme?.themeImages[3]
                              ? singleTheme?.themeImages[3]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <img
                          src={
                            singleTheme?.themeImages[4]
                              ? singleTheme?.themeImages[4]
                              : imgNotFound
                          }
                          alt="hotel-image"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <p
                  className={`${styles.description}`}
                  dangerouslySetInnerHTML={{
                    __html: singleTheme?.description,
                  }}
                ></p>
              </div>
            </div>
          </section>

          <div className="container pb_30 " id="themePackages">
            <div className="">
              {singleTheme?.themePackages &&
                singleTheme.themePackages.length > 0 && (
                  <>
                    <h3 className="new_ui_heading text_left">
                      <span>Showing All Packages in {themeName} Theme </span>
                    </h3>
                    <div className="theme_card_flex">
                      {singleTheme?.themePackages?.map((data, index) => (
                        <NewUIPackageCard
                          key={index}
                          imgSrc={
                            data?.featuredImage
                              ? data?.featuredImage
                              : imgNotFound
                          }
                          title={data.packageName}
                          packageHub={data.packageHub}
                          duration={data.totalDays}
                          nightDuration={data.totalNights}
                          price={data.startingPrice}
                          bookingLink={data.bookingLink}
                          detailsLink={data.detailsLink}
                          packagehandle={data.packagehandle}
                          canBookable={data?.canBookable}
                          packageId={data.packageId}
                          setShowSendEnquiryPopup={setShowSendEnquiryPopup}
                          markupData={markupData}
                          NoPax={data?.NoPax}
                          packageItinerary={data?.packageItinerary}
                        />
                      ))}
                    </div>
                  </>
                )}
            </div>
            {/* <main>
                    <FilterHoliday />
                </main> */}
          </div>

          {/* {showSendEnquiryPopup && (
        <SendEnquiryPopup
          package_id={""}
          setshowRatePopup={setShowSendEnquiryPopup}
          typeDetail="package"
        />
      )} */}
        </section>
      )}

      {showSendEnquiryPopup && (
        <NewSendEnquiryPopup
          package_id={""}
          setshowRatePopup={setShowSendEnquiryPopup}
          typeDetail="package"
        />
      )}
      <NewFooterUI />
    </>
  );
}

export default AllThemesPackages;
